import { useEffect, useRef, useState } from "react";
import { config } from "../Constants";
import useAuth from "../context/AuthProvider";
import React from "react";
import { TaxTransactionReportModel, TaxTransactionReportModel_Resp } from "../models/TaxTransactionReportModel";
import { Box, Stack, width } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Chip, FormControl, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, TextField, Switch } from "@mui/material";
import { writeXlsxFile } from "../helper/utils";
//import { FieldAttributes, useField, useFormikContext } from "formik";
import { Field, FieldArray, FieldAttributes, Form, Formik, useField, useFormik, useFormikContext } from 'formik';
import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DiligentSearchList, FMFilters, DiligentTabs } from "../components/Lists/DiligentSearchList";
import Swal from "sweetalert2";
import DiligentMarkCompleted from "./DiligentMarkCompleted";
import moment from "moment";
import { apiClient } from "../helper/api";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";

interface ModelForFilters {
    completedPage?: boolean;
    homeState?: string,
    insuredName?: string,
    policyNumber?: string,
    invoiceNumber?: string,
    needDiligentSearch?: string,
    diligentSearchNotes?: string,
    suspended?: string,
    transactionType?: string
    carrier?: string,
    naic?: string,
    invDate?: string,
    policyEffDate?: string,
    policyExpDate?: string,
    grossPremium?: string,
    client?: string,
    diligentSearchCompleted?: string,
    pageSize?: number;
    pageNumber?: number; 
    field?: string; 
    sort?: string;
    customerIds?: string;
    dateCompleted?: string;
    
    // Month/Year filtering properties
    month?: string;
    year?: string;
}

export const DiligentSearch = () => {

    const { user } = useAuth();
    const token = user?.token;
    const [loading, setloading] = useState(false);

    const initValue: TaxTransactionReportModel_Resp = {
        getOutstandingFilingsReport_Respdata: [],
        totalCount: 0,
        needDiligentSearch: undefined,
        diligentSearchCompleted: undefined,
        dateCompleted: undefined
    }

    const [ReportModule, setReportModule] = useState<TaxTransactionReportModel_Resp>(initValue)
    const [tabValue, setTabValue] = useState<DiligentTabs>(DiligentTabs.OpenDiligent)
    const [selectedRows, setSelectedRows] = useState<TaxTransactionReportModel[]>()
    const [openCompletedDialog, setOpenCompletedDialog] = useState<string>('')
    const [_currentPage, setCurrentPage] = React.useState(1)
    const [_pageSize, setPageSize] = React.useState(50)
    
    const sortRef = useRef<GridSortModel>([])
    const filterRef = useRef<GridFilterModel>()
    const customersRef = useRef<string[]>([])
    const [selectedCustomers, setSelectedCustomers] = React.useState<string[] | string>([]);
    
    // Removed month/year state variables - only using customer filtering for main page
    
    // Monthly export state variables (admin-only)
    const [exportMonth, setExportMonth] = useState<string>((new Date().getMonth() + 1).toString());
    const [exportYear, setExportYear] = useState(new Date().getFullYear().toString());

    const keysNamesFromXlsx = [
        'HomeState', 'InsuredName', 'PolicyNumber', 'InvoiceNumber',
        'TransactionType', 'Carrier', 'NAIC', 'InvoiceDate', 'PolicyEffDate', 'PolicyExpDate',
        'GrossPremium','Client', 'DiligentSearchToGMAC', 'Suspended', 'NeedDiligentSearch', 'DiligentSearchNotes',
        'DiligentSearchCompleted', 'DateCompleted'
    ]

    const keyNames: (keyof TaxTransactionReportModel)[] = [
        'homeState', 'insuredName', 'policyNumber', 'invoiceNumber',
        'transactionType', 'carrier', 'naic', 'invDate', 'policyEffDate', 'policyExpDate', 
        'grossPremium', 'client', 'diligentSearchToGmac', 'suspended', 'needDiligentSearch', 'diligentSearchNotes',
        'diligentSearchCompleted', 'dateCompleted'
    ]

    const handleOpenCompletedDialog = (status: string) => {
        setOpenCompletedDialog(status);
    };

    const handleCloseCompletedDialog = () => {
        setOpenCompletedDialog('');
    };

    // Monthly export handlers (admin-only)
    const handleExportMonthChange = (event: SelectChangeEvent<string>) => {
        setExportMonth(event.target.value);
    };

    const handleExportYearChange = (event: SelectChangeEvent<string>) => {
        setExportYear(event.target.value);
    };

    // Trigger data fetch when tab changes
    useEffect(() => {
        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    }, [tabValue]);

    
    const handleSubmitCompletedDialog = (completedDate: string) => {
        setOpenCompletedDialog('');
        setloading(true);
        var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
        var Ids = customerPolicyIds.join(',')
        apiClient(`/DiligentSearch/updateDiligentSearchCompleted?dateCompleted=${completedDate}&ids=${Ids}`, {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
        })
        .then((res) => {
            if (!res) return
            setSelectedRows([]);
            Swal.fire({
                title: "Successful!",
                text: "Success",
                icon: "success",
                confirmButtonText: "OK",
            })

            fetchNewData(_pageSize, _currentPage, tabValue);
            setloading(false);
        })
        .finally(() => {
            setloading(false);
        });
        

    };
    
    const getDiligentData = async (pageSize: number, pageNumber: number, selectedTab: DiligentTabs, newFilters?: GridFilterModel, newSort?: GridSortModel) => {
        
        setloading(true);
        const options: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: 'numeric' };
        const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current]
        var customerIds = selectedCustomerIds.join(',');
        const initFilterModel: ModelForFilters = {
            //completedPage: 'false'
        }
        initFilterModel.completedPage = selectedTab === DiligentTabs.CompletedDiligent;
        initFilterModel.pageNumber = pageNumber;
        initFilterModel.customerIds = customerIds
        initFilterModel.pageSize = pageSize;
        if (newSort) {
            initFilterModel.field = newSort[0]?.field ?? '';
            initFilterModel.sort = newSort[0]?.sort ?? '';
        }

        initFilterModel.homeState = newFilters?.items.find(m => m.columnField === "homeState")?.value;
        initFilterModel.insuredName = newFilters?.items.find(m => m.columnField === "insuredName")?.value;
        initFilterModel.policyNumber = newFilters?.items.find(m => m.columnField === "policyNumber")?.value;
        initFilterModel.invoiceNumber = newFilters?.items.find(m => m.columnField === "invoiceNumber")?.value;
        initFilterModel.needDiligentSearch = newFilters?.items.find(m => m.columnField === "needDiligentSearch")?.value;
        initFilterModel.diligentSearchNotes = newFilters?.items.find(m => m.columnField === "diligentSearchNotes")?.value;
        initFilterModel.suspended = newFilters?.items.find(m => m.columnField === "suspended")?.value;
        initFilterModel.transactionType = newFilters?.items.find(m => m.columnField === "transactionType")?.value;
        initFilterModel.carrier = newFilters?.items.find(m => m.columnField === "carrier")?.value;
        initFilterModel.naic = newFilters?.items.find(m => m.columnField === "naic")?.value;
        initFilterModel.invDate = newFilters?.items.find(m => m.columnField === "invDate")?.value;
        initFilterModel.policyEffDate = newFilters?.items.find(m => m.columnField === "policyEffDate")?.value;
        initFilterModel.policyExpDate = newFilters?.items.find(m => m.columnField === "policyExpDate")?.value;
        initFilterModel.grossPremium = newFilters?.items.find(m => m.columnField === "grossPremium")?.value;
        initFilterModel.client = newFilters?.items.find(m => m.columnField === "client")?.value;
        initFilterModel.diligentSearchCompleted = newFilters?.items.find(m => m.columnField === "diligentSearchCompleted")?.value;
        initFilterModel.dateCompleted = newFilters?.items.find(m => m.columnField === "dateCompleted")?.value;
        
        // No month/year filtering for main page - only customer filtering

        const response = await apiClient(`/DiligentSearch/getDiligentSearchFilteredData`, {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(initFilterModel)
        }).then((responseJson) => {
            if (!responseJson) return
    
            setloading(false);
            if (responseJson.data != null && responseJson.data.totalCount > 0) {
                // setReportModule(responseJson.data);
                return responseJson.data
            } else {
                // setReportModule(initValue);
                return initValue
            }
        }).finally(() => {
            setloading(false);
        });
        return response
    }
    const fetchNewData = async(pageSize: number, pageNumber: number, selectedTab: DiligentTabs, newFilters?: GridFilterModel, newSort?: GridSortModel) => {
        const res = await getDiligentData(pageSize, pageNumber, selectedTab, newFilters, newSort)
        setReportModule(res)
    }

    const handleTabChange = (tab: DiligentTabs) => {
        // setCompletedPage(tab == 2)
        setloading(true);
        setTabValue(tab);
        setPageSize(50);
        setCurrentPage(1);
        fetchNewData(50, 1, tab);
    };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    const onExportXlsx = (values: TaxTransactionReportModel[]) => {
        setloading(true);
        if (values.length === 0) {
            return
        }
        let filteredKeyNames = keyNames;
        if (tabValue === DiligentTabs.OpenDiligent) {
            filteredKeyNames = keyNames.filter(key => key !== 'dateCompleted' && key !== 'diligentSearchCompleted');
        }
        const items = values.map(item => {
            const update: (string | number | Date | undefined)[] = [];
    
            filteredKeyNames.map((key: keyof TaxTransactionReportModel) => {
                if (key === 'dateCompleted') {
                    update.push(moment.utc(item[key]).format("MM/DD/YYYY"));
                } else {
                    update.push(item[key]);
                }
            });
    
            return update;
        });
        const updates = [
            filteredKeyNames,
            ...items
        ]
        writeXlsxFile(updates)
        setloading(false);
    }
   
    const handleExportXlsxNew = async (val: TaxTransactionReportModel[]) => {
        try {
            setloading(true);

            // Show loading dialog
            Swal.fire({
                title: 'Generating Excel...',
                text: 'Please wait while we generate your Diligent Search Excel file.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Prepare simplified request payload for the new API endpoint
            const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current];
            const partnerId = selectedCustomerIds.length > 0 ? parseInt(selectedCustomerIds[0]) : 127; // Default to 127 if no customer selected
            
            // Get the actual partner name from the customer data
            const selectedCustomer = Customer.find(customer => customer.partnersId === partnerId);
            const partnerName = selectedCustomer ? selectedCustomer.customerName : "Default Partner";

            const requestPayload = {
                partnerId: partnerId,
                clientName: partnerName,
                userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            };

            console.log('🔍 DILIGENT SEARCH EXCEL EXPORT REQUEST:', requestPayload);

            const response = await apiClient('/MonthEndBilling/generate-diligent-search-internal-excel', {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(requestPayload),
            });

            Swal.close();

            console.log('📥 DILIGENT SEARCH EXCEL EXPORT RESPONSE:', response);

            if (response && response.status === true && response.data && response.data.excel_url) {
                // Success - download the Excel file
                const link = document.createElement('a');
                link.href = response.data.excel_url;
                link.download = response.data.filename || 'diligent_search_export.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                Swal.fire({
                    icon: 'success',
                    title: 'Excel Generated Successfully!',
                    text: `File: ${response.data.filename} (${response.data.original_data_count} records)`,
                    confirmButtonText: 'OK'
                });
            } else {
                // Handle failure cases
                const errorMessage = response?.message || 'Failed to generate Excel file';
                Swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }

            setSelectedRows([]);
            setloading(false);
        } catch (error) {
            console.error('Error in handleExportXlsxNew:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Export Failed',
                text: 'An error occurred while generating the Excel file.',
                confirmButtonText: 'OK'
            });
            setloading(false);
        }
    }

    // Monthly export function (admin-only)
    const handleMonthlyExport = async () => {
        try {
            // Get selected customer IDs
            const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current];
            
            // Validation: Ensure exactly one customer is selected
            if (!selectedCustomerIds || selectedCustomerIds.length === 0 || selectedCustomerIds[0] === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'No Customer Selected',
                    text: 'Please select a customer before exporting the monthly report.',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            if (selectedCustomerIds.length > 1) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Multiple Customers Selected',
                    text: 'Please select only ONE customer for the monthly export.',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK'
                });
                return;
            }

            setloading(true);

            // Show loading dialog
            Swal.fire({
                title: 'Generating Monthly Report...',
                text: 'Please wait while we generate your monthly Diligent Search report.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            const partnerId = selectedCustomerIds.length > 0 ? parseInt(selectedCustomerIds[0]) : 127; // Default to 127 if no customer selected
            
            // Get the actual partner name from the customer data
            const selectedCustomer = Customer.find(customer => customer.partnersId === partnerId);
            const partnerName = selectedCustomer ? selectedCustomer.customerName : "Default Partner";

            const requestPayload = {
                partnerId: partnerId,
                month: parseInt(exportMonth),
                year: parseInt(exportYear),
                clientName: partnerName,
                userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            };

            console.log('🔍 MONTHLY DILIGENT SEARCH EXPORT REQUEST:', requestPayload);

            const response = await apiClient('/MonthEndBilling/generate-diligent-search-internal-excel', {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(requestPayload),
            });

            Swal.close();

            if (response && response.status && response.data && response.data.excel_url) {
                // Download the Excel file
                const link = document.createElement('a');
                link.href = response.data.excel_url;
                link.download = response.data.filename || `diligent_search_monthly_${exportMonth}_${exportYear}.xlsx`;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Show success message
                Swal.fire({
                    title: 'Success!',
                    text: `Monthly report for ${exportMonth}/${exportYear} downloaded successfully! ${response.data.original_data_count || 0} records processed.`,
                    icon: 'success',
                    confirmButtonColor: '#02A4E3',
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                // API returned an error or invalid response
                const errorMessage = response?.message || response?.error || response?.data?.message || 'Invalid response from server';
                Swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: errorMessage,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#02A4E3'
                });
            }

            setloading(false);
        } catch (error: any) {
            console.error('Error in handleMonthlyExport:', error);
            Swal.close();
            
            // Extract error message from the error object
            let errorMessage = 'An error occurred while generating the monthly report.';
            
            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error?.message) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }
            
            Swal.fire({
                icon: 'error',
                title: 'Export Failed',
                text: errorMessage,
                confirmButtonText: 'OK',
                confirmButtonColor: '#02A4E3'
            });
            setloading(false);
        }
    }

    const handleCustomersChange = async (e: string) => {
        var result = selectedCustomers.toLocaleString().split(',').filter((item) => item !== e);
        setSelectedCustomers(result);
        onChangeCustomer(result);
    }

    async function onChangeCustomer(customers: string | string[]) {
        const selectedCustomerIds = Array.isArray(customers) ? customers : [customers]
        customersRef.current = selectedCustomerIds
        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    }
    const initialUserdata = { partnersId: 0, customerName: "" };
    const [Customer, setCustomer] = useState([initialUserdata]);
    const fetchCustomer = () => {
        apiClient("/DiligentSearch/getPartnersByDiligent", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (!responseJson) return
                setCustomer(responseJson.data);
            })
    };

    const FMSelectCustomer: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {

        return (
            <FormControl fullWidth sx={{}}  >
                <InputLabel id="State-Select-Label">Customers</InputLabel>
                <Select
                    // {...field}
                    disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                    label={"Customers"}

                    className="border-round main-form-2"
                    multiple
                    labelId="State-Select-Label"
                    value={selectedCustomers}
                    IconComponent={ExpandMoreIcon}
                    onChange={(e) => {
                        const selectedValues = e.target.value;
                        setSelectedCustomers(selectedValues);
                        onChangeCustomer(selectedValues);
                    }}
                    renderValue={(selected) => (
                        <Stack gap={1} direction="row" flexWrap="wrap">
                            {selected.toLocaleString().split(',').map((value) => (
                                <Chip

                                    key={value}
                                    label={Customer.find(x => x.partnersId.toString() === value)?.customerName}
                                    onDelete={() =>
                                        handleCustomersChange(value)
                                    }
                                    disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                                    deleteIcon={
                                        <CancelIcon
                                            onMouseDown={(event) => event.stopPropagation()}
                                        />
                                    }
                                />
                            ))}

                        </Stack>
                    )}
                >
                    {Customer.map((Cust, key) =>
                        <MenuItem key={key} value={Cust.partnersId}>  {Cust.customerName} </MenuItem>
                    )}
                </Select>
            </FormControl>
        )
    }

    useEffect(() => {
        fetchNewData(50, 1, tabValue);
        fetchCustomer();
    }, [])

    const handleMarkCompleted = () => {
        handleOpenCompletedDialog('true');
    }
    return (
        <><LocalizationProvider dateAdapter={AdapterDayjs}>

            <Box>
                <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
                    {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
                </div>
   
            </Box>
          <Box sx={{ width: "100%" }}>
            <Box>
              <div >
                
                  <div className="col-lg-12    ">
                    <div
                      className=" d-flex  "
                      style={{ marginBottom: "28px" }} role="group"
                      aria-label="Basic example"
                    >
                      <React.Fragment>
    
                        <div className="col-6  text-center ">
                          <button type="button"
                            className={`btn-tab btn ${tabValue === DiligentTabs.OpenDiligent ? "btn-Selected" : "btn-primary1"
                              }`}
                            {...a11yProps(1)}
                            onClick={() => handleTabChange(DiligentTabs.OpenDiligent)}
                          >
                            Open Diligent Searches
                          </button>
                        </div>
                        <div className="col-6 text-center">
                            <button
                                type="button"
                                
                                className={`btn-tab btn ${tabValue === DiligentTabs.CompletedDiligent ? "btn-Selected" : "btn-primary"
                                }`}
                                {...a11yProps(2)}
                                onClick={() => handleTabChange(DiligentTabs.CompletedDiligent)}
                            >
                                Completed Diligent Searches
                            </button>
                        </div>
                        </React.Fragment>
                        </div>
                  </div>
                  </div>
                  </Box>
                  <Box>
                  <div className="col-lg-12    ">
                    <div
                      className=" d-flex  "
                      style={{ marginBottom: "28px" }} role="group"
                      aria-label="Basic example"
                    >
                    <Grid
                        container
                        spacing={3} // Adjust the spacing between grid items
                        className="filter-grid"
                        display="flex"
                        justifyContent="flex-end" // Align the buttons to the right
                        alignItems="right"
                    >
                    <React.Fragment>
                        {/* Customer Dropdown - Always visible */}
                        <Grid item xl={2} sm={12} xs={12} minWidth={150}>
                            <FormControl sx={{ width: '100%' }}>
                                <FMSelectCustomer name="customerIds" />
                            </FormControl>
                        </Grid>
                        
                        {/* Admin-only Month/Year controls */}
                        {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) && (
                            <>
                                <Grid item xl={2} sm={12} xs={12} minWidth={150}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Month</InputLabel>
                                        <Select
                                            value={exportMonth}
                                            onChange={handleExportMonthChange}
                                            label="Month"
                                            IconComponent={ExpandMoreIcon}
                                            sx={{ height: '2.8rem' }}
                                        >
                                            <MenuItem value="1">January</MenuItem>
                                            <MenuItem value="2">February</MenuItem>
                                            <MenuItem value="3">March</MenuItem>
                                            <MenuItem value="4">April</MenuItem>
                                            <MenuItem value="5">May</MenuItem>
                                            <MenuItem value="6">June</MenuItem>
                                            <MenuItem value="7">July</MenuItem>
                                            <MenuItem value="8">August</MenuItem>
                                            <MenuItem value="9">September</MenuItem>
                                            <MenuItem value="10">October</MenuItem>
                                            <MenuItem value="11">November</MenuItem>
                                            <MenuItem value="12">December</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xl={2} sm={12} xs={12} minWidth={150}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Year</InputLabel>
                                        <Select
                                            value={exportYear}
                                            onChange={handleExportYearChange}
                                            label="Year"
                                            IconComponent={ExpandMoreIcon}
                                            sx={{ height: '2.8rem' }}
                                        >
                                            {Array.from({ length: 10 }, (_, i) => {
                                                const year = new Date().getFullYear() - 5 + i;
                                                return (
                                                    <MenuItem key={year} value={year.toString()}>
                                                        {year}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                        
                        {/* Mark Completed button - Only for Open Diligent Searches */}
                        {tabValue === DiligentTabs.OpenDiligent && selectedRows?.length !== 0 && selectedRows?.length !== undefined ? (
                            <Grid item minWidth={150} className="select-input-border d-flex">
                                <button
                                    onClick={() => handleMarkCompleted()}
                                    className="active-btn-blue"
                                    style={{ width: '100%' }}
                                >
                                    Mark Completed
                                </button>
                            </Grid>
                        ) : ''}
                        
                        {/* Export buttons side by side */}
                        <Grid item className="select-input-border d-flex">
                            <button
                                onClick={() => onExportXlsx(ReportModule.getOutstandingFilingsReport_Respdata || [])}
                                className="active-btn-blue"
                            >
                                Export
                            </button>
                        </Grid>
                        
                        {/* Admin-only Export Monthly button */}
                        {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) && (
                            <Grid item className="select-input-border d-flex">
                                <button
                                    onClick={handleMonthlyExport}
                                    className="active-btn-blue"
                                >
                                    Export Monthly
                                </button>
                            </Grid>
                        )}
                        </React.Fragment>
                    </Grid>
                    </div>
                  </div>
                </Box>       
          </Box>

        </LocalizationProvider>
        {openCompletedDialog && <DiligentMarkCompleted
                open={!!openCompletedDialog}
                handleClose={handleCloseCompletedDialog}
                handleSubmit={handleSubmitCompletedDialog}
                selectedRows={selectedRows}
            />}
            
        <Box
          overflow={"scroll"}
          sx={{
            height: "calc(100% - 60px)",
            width: "100%"
          }}
        >
            <DiligentSearchList
                ReportModuleCL={ReportModule}
                fetchDataMain={fetchNewData}
                tabValue={tabValue}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                _currentPage={_currentPage}
                setCurrentPage={setCurrentPage}
                _pageSize={_pageSize}
                setPageSize={setPageSize}
                sortRef={sortRef}
                filterRef={filterRef}
            />
        </Box>
        </>
    );
}
